import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Tooltip
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Internal_Property_List
} from '../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropertyCard from './components/PropertyCard';

function Index({}) {
    const [propertyDetail, setPropertyDetail] = useState([]);
    const [loaded, setLoading] = useState(false);
    const [propertyTags,setPropertyTags]=useState([]);
    useEffect(() => {
        LoadData();
    }, []);
    const LoadData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                let lst =[];
                res.data.map((l) => {
                  if (
                    l.tagList !== undefined &&
                    l.tagList !== null &&
                    l.tagList.length > 0
                  )
                    l.tagList.map((t) => {
                      if (!lst.includes(t)) lst.push(t);
                    });
                });
                setPropertyTags(lst);                
                setPropertyDetail(res.data);
                setLoading(false);
            })
            .catch((err) => console.log('err', err));
    }
    return (
        <Fragment>
            {!loaded && (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            {propertyDetail.length > 0 &&
                                propertyDetail.map((room, index) => (
                                    <Colxx xxs="12" xs="6" lg="3" key={index}>
                                        <PropertyCard propertyTags={propertyTags} property={room} LoadData={LoadData} />
                                    </Colxx>
                                ))}
                        </Row>
                    </Colxx>
                </Row>)}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId
    };
};
export default injectIntl(connect(mapStateToProps, {})(Index));
